// 코치마크가 떠 있거나 노출 여부를 확인하는 동안에는 다른 안내(앱 설치 카드 등)를 미룬다.
let active = false;
let waiters = [];

export function setCoachmarkActive(value) {
  active = value;
  if (!active) {
    const queued = waiters;
    waiters = [];
    queued.forEach((cb) => cb());
  }
}

// 코치마크가 없으면 바로, 있으면 닫힌 뒤에 cb 실행
export function whenCoachmarkIdle(cb) {
  if (!active) cb();
  else waiters.push(cb);
}
